<form class="action-form">
  <span class="title">{{ 'VISMA.CONNECT' | translate }}</span>
  <div class="form-group">
    {{ 'VISMA.CONNECT_REDIRECT_INFO' | translate }}
  </div>
  <div>
    @if (vismaUrl) {
      <a class="btn btn-active" [href]="vismaUrl">{{ 'OK_BTN' | translate }}</a>
    }
    <button class="btn link-btn ml-2" (click)="close()">{{ 'CANCEL_BTN' | translate }}</button>
  </div>
</form>
